import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminMomentsAnalytics = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/moments/analytics/index.vue')
    createVueApp(ShowPage, { props })
  }
}
